export const RIGHT = "right";
export const LEFT = "left";
export const BOTH = "both";

export const getPositionTypes = [RIGHT, LEFT, BOTH];
